// /inspeccion y sus subrutas (no /inspeccionar ni similares).
export const esRutaInspeccion = (pathname = '') =>
  pathname === '/inspeccion' || pathname.startsWith('/inspeccion/');
